import type { ContextValue } from '../../components/SunriseHoldoutExperimentContextProvider';

import type { Props } from './index';

export type AmountInputProps = {
	amountInputValue: number | undefined;
	currencySymbol: string;
	currencyRef: React.RefObject<HTMLSpanElement>;
	isSelected: boolean;
};

export type AmountInputState = {
	amountInputClasses: string;
	amountInputStyle: Record<string, string> | Record<string, Record<string, string>>;
};

export function isAmountInputState(props: Props): props is AmountInputProps {
	return !!(
		props && ['amountInputValue', 'currencySymbol', 'currencyRef', 'isSelected'].every((prop) => prop in props)
	);
}

type Style = {
	paddingLeft: string;
	color: string;
	height?: string;
	fontSize?: string;
};

export function amountInputState(
	props: AmountInputProps & {
		enabled: boolean;
		shouldUseBlueCards: ContextValue['shouldUseBlueCards'];
	},
): AmountInputState {
	const { currencyRef, currencySymbol, isSelected, enabled, shouldUseBlueCards } = props;

	if (!enabled) {
		return {
			amountInputClasses: '',
			amountInputStyle: {},
		};
	}

	const classes = [];

	classes.push('outline-none');
	classes.push('placeholder:text-[#403A49]');

	if (isSelected) {
		// ensure that a white outline does not appear when selected
		classes.push('outline-offset-[-2px]');
		// ensure that the outline remains when selected and input loses focus
		classes.push('border-2 border-stroke-selected');
	} else {
		// ensure that the input size does not change when selected
		classes.push('outline-offset-[-1px]');
	}

	const SPACING_AMOUNT = 16;
	const currencyWidth = currencyRef.current?.clientWidth || (currencySymbol.length + 1) * SPACING_AMOUNT;
	const style: Style = {
		paddingLeft: `${currencyWidth + SPACING_AMOUNT}px`,
		color: '#766F81',
	};

	if (shouldUseBlueCards) {
		style.height = '52px';
		style.fontSize = '16px';
		style.color = '#403A49';
	}

	return {
		amountInputClasses: classes.join(' '),
		amountInputStyle: style,
	};
}
